import React, { Fragment } from "react";
import { Card } from "react-bootstrap";
import { MedicalLicense } from "../../Physician/Models/MedicalLicense";
import { StateWithCountryLookupItem } from "../Models/StateWithCountryLookupItem";
import MedicalLicenseCard from "./MedicalLicenseCard";

interface IProps {
    medicalLicenses: Array<MedicalLicense>;
    states: Array<StateWithCountryLookupItem>;
    handleRemove: (medicalLicense: MedicalLicense) => void;
    updateMedicalLicense: (medicalLicense: MedicalLicense) => void;
}

export function MedicalLicenseList(props: IProps) {

    return (
        <Fragment>
        {props.medicalLicenses?.length > 0 ?
            props.medicalLicenses.map((license: MedicalLicense) => {
                return <MedicalLicenseCard key={license.licenseNumber} medicalLicense={license} states={props.states}
                    handleRemove={(medicalLicense: MedicalLicense) => props.handleRemove(medicalLicense)}
                    updateMedicalLicense={(medicalLicense: MedicalLicense) => props.updateMedicalLicense(medicalLicense)} />
            })
            :
            <Card.Text bsPrefix="ml-2">No medical licenses</Card.Text>}
        </Fragment>
    );
}